// ----- VUE 3 Imports -----
import {computed} from 'vue'; // For VUE 3
import {createAcl, defineAclRules, useAcl} from 'vue-simple-acl';
import store from "./store";
import router from "./router";


const user = computed(() => store.state.authModule._user);

const rules = () => defineAclRules((setRule) =>
{
    setRule('admin', (user) => user.is_admin);
});

const simpleAcl = createAcl({
    user, // short for user: user
    rules, // short for rules: rules
    router, // OPTIONAL, short for router: router 
    // other optional vue-simple-acl options here... See Vue Simple ACL Options below
});

export default simpleAcl;